import { createAction, createSlice } from "@reduxjs/toolkit";

const getAllMyLearningSlice = createSlice({
  name: "getAllMyLearning",
  initialState: { data: [], pagination: null, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      const { data, pagination } = action.payload;
      state.data = data.data;
      state.pagination = pagination;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = getAllMyLearningSlice;
const getAllMyLearningAction = createAction(name);

export {
  getAllMyLearningAction,
  actions as getAllMyLearningActions,
  reducer as getAllMyLearningReducer,
};
